import TYPES from '../../action-types';

/**
 * Change color on assets immediately
 * @param {string[]} ids
 * @param {string} value
 */
const changedColor = (ids, value, timestamp, user) => (dispatch) => {
  dispatch({
    type: TYPES.ASSETS.CHANGE_COLOR.COMPLETE,
    payload: {
      ids,
      keys: ['color', 'colorAt', 'colorBy'],
      values: [value, timestamp, user],
      eventType: 'color',
      userId: user._id,
    },
  });
};

export default changedColor;
